import React from 'react';
import { FastField, getIn } from 'formik';
import { FormControl } from '@mui/material';
import { isString } from 'lodash';
import { TimePicker } from '@mui/x-date-pickers';

const TimePickerFormik = ({ name, label, required, disabled, onChange, fullWidth, InputLabelProps, views }) => (
    <FastField
        name={ name }
        shouldUpdate={ (nextProps, currentProps) => {
            if (getIn(nextProps.formik.values, name) !== getIn(currentProps.formik.values, name)) return true;
            if (getIn(nextProps.formik.errors, name) !== getIn(currentProps.formik.errors, name)) return true;
            if (getIn(nextProps.formik.touched, name) !== getIn(currentProps.formik.touched, name)) return true;
            if (nextProps.disabled !== currentProps.disabled) return true;
            if (nextProps.required !== currentProps.required) return true;

            return false;
        } }
    >
        { ({ form: { errors, setFieldValue }, field }) => (
            <FormControl fullWidth={ fullWidth }>
                <TimePicker
                    { ...field }
                    value={ (isString(field?.value) && field?.value === '') ? null : field?.value }
                    label={ label }
                    disabled={ disabled }
                    onChange={ (newTime) => {
                        setFieldValue(name, newTime);
                        onChange && onChange(newTime);
                    } }
                    slotProps={ {
                        textField: {
                            required: required,
                            helperText: getIn(errors, field?.name),
                            error: !!getIn(errors, field?.name),
                            InputLabelProps: {
                                ...InputLabelProps
                            }
                        }
                    } }
                    views={ views }
                />
            </FormControl>
        ) }
    </FastField>
);

export default TimePickerFormik;